import * as React from 'react';
import * as styles from './DueDateCompletionCheckbox.scss';
import { observer } from 'mobx-react-lite';
import { Checkbox, ICheckboxStyles } from '@fluentui/react/lib/Checkbox';
import loc from 'owa-localize';
import { markItemAsCompletedLabel } from '../dueDates.locstring.json';

const checkBoxStyles: ICheckboxStyles = {
    root: styles.markAsCompleted,
    text: styles.checkboxText,
};

export default observer(function DueDateCompletionCheckbox({
    isCompleted,
    disabled,
    onIsCompletedChanged,
}: {
    isCompleted: boolean;
    disabled: boolean;
    onIsCompletedChanged: (newValue: boolean) => void;
}) {
    const onChange = React.useCallback(
        (_, checked?: boolean) => {
            onIsCompletedChanged(!!checked);
        },
        [onIsCompletedChanged]
    );

    return (
        <Checkbox
            styles={checkBoxStyles}
            label={loc(markItemAsCompletedLabel)}
            disabled={disabled}
            checked={isCompleted}
            onChange={onChange}
        />
    );
});
